import { render, staticRenderFns } from "./AmenitiesFilter.vue?vue&type=template&id=c2f5e2da&"
import script from "./AmenitiesFilter.vue?vue&type=script&lang=js&"
export * from "./AmenitiesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports